import styled from "styled-components";

export const InfoCard = styled.li`
  border: 2px solid #104467;
  border-radius: 20px;
  width: 400px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 15px;
`;

export const CardItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
`;

export const CardHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  word-break: break-word;
  overflow-wrap: break-word;

  h3 {
    font-size: 1.2rem;
    color: #104467;
  }

  h4 {
    font-size: 1rem;
    color: #104467;
  }

  span {
    color: #104467;
    font-weight: 500;

    max-height: 150px;
    overflow-y: auto;
    word-break: break-word;
    display: inline-block;
    white-space: pre-wrap;
  }
`;

export const TopBarActions = styled.div`
  display: flex;
  gap: 5px;
  height: 25px;
  color: #104467;
`;

export const IconContainer = styled.div`
  background-color: blanchedalmond;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;
